module.exports = __webpack_public_path__ + "static/media/cadastroColaboradorEnterprise.dfc36035.jpg";